import $ from "../../libs/jquery-3.3.1.min.js"
import {gsap} from "../../libs/gsap/all.js"

export class Timer {

  // Constructor
  constructor() {
    this.currentTimeline = null;
    this.resetTimerTimeline = null;
  }

  startTimer($el, duration, callback = null) {
    // Build animation timeline
    this.killTimeline();
    this.currentTimeline = gsap.timeline();

    // Timer progress
    this.currentTimeline.set($el.find("circle"), {
      strokeDasharray: 201.062,
      strokeDashoffset: 201.062
    });
    this.currentTimeline.to($el.find("circle"), {strokeDashoffset: 0, duration: duration, ease: 'linear'});

    // Trigger callback
    if (callback && typeof callback === "function") {
      this.currentTimeline.add(() => {
        callback();
      });
    }
  }

  pauseTimer() {
    if (this.currentTimeline) {
      this.currentTimeline.pause();
    }
  }

  resetTimer() {
    if (this.currentTimeline) {
      this.killTimeline(this.resetTimerTimeline);
      this.resetTimerTimeline = gsap.timeline();

      this.resetTimerTimeline.to(this.currentTimeline, {
        progress: 0,
        duration: 0.50,
        onUpdate: () => {
          this.currentTimeline.progress(this.currentTimeline.progress());
        },
        onComplete: () => {
          this.currentTimeline.play();
        }
      });
    }
  }

  stopTimer() {
    // Kill timelines
    this.killTimeline(this.currentTimeline);
    this.killTimeline(this.resetTimerTimeline);
  }

  killTimeline(timeline) {
    if (timeline) {
      timeline.kill();
      timeline = null;
    }
  }

}
